var Folkspel = {

	init: function() {
		$.ajaxSetup({
			contentType: 'application/json',
			type: "POST",
			dataType: 'json'
		});
	}
}

Folkspel.init();